const erpNextServicesData = [
  {
    title: "ERPNext Development",
    description:
      "Build custom ERPNext modules aligned with your business workflows and analytics.",
    bullets: [
      "Process Automation",
      "Custom Module Creation",
      "User-Centric Dashboards",
      "Performance Optimization",
    ],
    minHeight: 420,
  },
  {
    title: "ERPNext Implementation",
    description:
      "End-to-end ERPNext setup — from planning and deployment to training and rollout.",
    bullets: [
      "Requirement Analysis",
      "System Configuration",
      "Data Migration",
      "Go-Live Support",
    ],
    minHeight: 420,
  },
  {
    title: "ERPNext Consulting",
    description:
      "Strategic advisory to align ERPNext capabilities with your business objectives.",
    bullets: [
      "Process Mapping",
      "Workflow Optimization",
      "Technology Roadmap",
      "Cost Optimization",
    ],
    minHeight: 420,
  },
  {
    title: "ERPNext Integration",
    description:
      "Integrate ERPNext with third-party tools and platforms for unified operations.",
    bullets: [
      "API & Plugin Integrations",
      "Payment Gateway Setup",
      "CRM & HRM Connectivity",
      "Data Synchronization",
    ],
    minHeight: 420,
  },
  {
    title: "ERPNext Customization",
    description:
      "Tailor ERPNext to match your processes, teams, and branding needs.",
    bullets: [
      "UI/UX Enhancements",
      "Module Customization",
      "Role-Based Access Controls",
      "Advanced Reporting",
    ],
    minHeight: 420,
  },
  {
    title: "ERPNext Migration & Upgrade",
    description:
      "Move from legacy ERP systems or upgrade existing ERPNext installations securely.",
    bullets: [
      "Version Upgrades",
      "Legacy Data Migration",
      "Risk Assessment",
      "Testing & Validation",
    ],
    minHeight: 420,
  },
  {
    title: "Data Analytics & Insights",
    description:
      "Turn ERPNext data into actionable intelligence for smarter decision-making.",
    bullets: [
      "Business Performance Dashboards",
      "Predictive Analysis",
      "Sales & Inventory Insights",
      "Real-Time Reporting",
    ],
    minHeight: 420,
  },
  {
    title: "ERP Maintenance & Support",
    description:
      "Comprehensive support and proactive maintenance for stable ERPNext operations.",
    bullets: [
      "Issue Resolution",
      "Regular Backups & Updates",
      "Performance Monitoring",
      "Continuous Improvement",
    ],
    minHeight: 420,
  },
  {
    title: "Security & Compliance",
    description:
      "Keep your ERPNext environment compliant, secure, and reliable.",
    bullets: [
      "Access Control",
      "Encryption Standards",
      "Compliance Audits",
      "Risk Management",
    ],
    minHeight: 420,
  },
];

// Named exports: centralize Integrations and Journey data for sections
export const erpNextIntegrations = [
  { name: "Shopify", sub: "E‑Commerce Sync", icon: "fa-brands fa-shopify" },
  {
    name: "WooCommerce",
    sub: "E‑Commerce Sync",
    icon: "fa-brands fa-wordpress",
  },
  { name: "Slack", sub: "Communication", icon: "fa-brands fa-slack" },
  {
    name: "Microsoft Teams",
    sub: "Communication",
    icon: "fa-brands fa-microsoft",
  },
  { name: "Razorpay", sub: "Payments", icon: "fa-solid fa-receipt" },
  { name: "Stripe", sub: "Payments", icon: "fa-brands fa-stripe-s" },
  {
    name: "Google Workspace",
    sub: "Emails & Calendar",
    icon: "fa-brands fa-google",
  },
  { name: "Outlook", sub: "Emails & Calendar", icon: "fa-brands fa-microsoft" },
  {
    name: "QuickBooks",
    sub: "Finance",
    icon: "fa-solid fa-file-invoice-dollar",
  },
  { name: "Tally", sub: "Finance", icon: "fa-solid fa-file-invoice" },
  {
    name: "WhatsApp Business",
    sub: "Notifications",
    icon: "fa-brands fa-whatsapp",
  },
];

export const erpNextJourneySteps = [
  {
    no: "01",
    icon: "fa-solid fa-magnifying-glass",
    stage: "Discovery & Audit",
    focus:
      "Deep business analysis, stakeholder interviews, and pain‑point mapping to define measurable outcomes.",
  },
  {
    no: "02",
    icon: "fa-solid fa-diagram-project",
    stage: "Solution Architecture",
    focus:
      "Blueprint workflows, permissions, and data models with clear governance and success metrics.",
  },
  {
    no: "03",
    icon: "fa-solid fa-screwdriver-wrench",
    stage: "Customization & Development",
    focus:
      "Build custom modules, server/client scripts, automations, and refined UI to drive adoption.",
  },
  {
    no: "04",
    icon: "fa-solid fa-plug",
    stage: "Integration & Data Migration",
    focus:
      "Secure API integrations, legacy data import with validations, and reconciliation plans.",
  },
  {
    no: "05",
    icon: "fa-solid fa-user-graduate",
    stage: "User Enablement",
    focus:
      "Role‑based training, UAT cycles, change management, and go‑live readiness.",
  },
  {
    no: "06",
    icon: "fa-solid fa-chart-line",
    stage: "Ongoing Evolution",
    focus:
      "Monitoring, analytics, SLA tuning, and continuous improvement sprints.",
  },
];

export default erpNextServicesData;
